document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cl-faq').forEach(function (faq) {
    faq.querySelectorAll('.cl-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cl-faq__item');
        var open = item.classList.contains('is-open');
        faq.querySelectorAll('.cl-faq__item').forEach(function (i) { i.classList.remove('is-open'); i.querySelector('.cl-faq__q').setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  document.querySelectorAll('[data-cl-leaders]').forEach(function (root) {
    var track = root.querySelector('.cl-leaders__track');
    var slides = root.querySelectorAll('.cl-leaders__slide');
    var dots = root.querySelectorAll('.cl-leaders__dot');
    var n = slides.length;
    var i = 0;
    function render() {
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    root.querySelectorAll('[data-cl-prev]').forEach(function (b) { b.addEventListener('click', function () { i = (i - 1 + n) % n; render(); }); });
    root.querySelectorAll('[data-cl-next]').forEach(function (b) { b.addEventListener('click', function () { i = (i + 1) % n; render(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { i = k; render(); }); });
  });
});
